// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import grey from "@material-ui/core/colors/grey"


// AMCHARTS
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
//import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// UTILS
// import * as moment from "moment"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashReasonsChart>")


// SETUP
// CHART
// am4core.useTheme(am4themes_animated)

const styles = theme => ({

    somestyle: {
        backgroundColor: grey[200]
    },
    
})


/*
const makeData_old = () => {

    const pointNum = 6
    const dataMin = 0
    const dataMax = 5

    let data = []
    
    for (let i = 0, point; i < pointNum; i++) {
        point = Math.floor(Math.random() * (dataMax - dataMin + 1) + dataMin)
        log.debug("makeData(): point =", point)
        data.push({
            "date": moment().subtract(i, "weeks").format("MM-DD-YYYY"),
            "value": point
        })
    }

    return data
}
*/

const makeData = () => {

    let data = [{
        "category": "Research",
        "value": 45,
        "target": 80
    }, {
        "category": "Marketing",
        "value": 60,
        "target": 75
    }, {
        "category": "Distribution",
        "value": 92,
        "target": 96
    }]
    
    return data
}


class FlashReasonsChart extends Component {
    constructor(props){
        super(props)
        log.debug("constructor(): we supposed to do stuff here now :)")
        log.debug("constructor(): this.props =", this.props)
        log.debug("constructor(): this.props.data =", this.props.data)
        this.state.data = this.props.data
    }

    state = {
        data: [],
    }

    componentDidMount_works() {
        let data = this.state.data

        log.debug("componentDidMount(): data =", data)

        // make chart
        let chart = am4core.create("reasonsChartDiv", am4charts.XYChart)
        chart.data = data

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.title.text = "title text" 

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.minWidth = 35;
        // valueAxis.title.text = "Importance" // remove text

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "value";

//        series.tooltipText = "{valueY.value}"
//        chart.cursor = new am4charts.XYCursor()

        this.chart = chart
        
    }


    componentDidMount() {
        log.debug("componentDidMount(): this.props.data =", this.props.data)

        let data = this.state.data

        log.debug("componentDidMount(): data =", data)
        // make chart
        let chart = am4core.create("reasonsChartDiv", am4charts.XYChart)
        chart.data = data


        // Category Axis
        var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.minGridDistance = 30
        categoryAxis.renderer.grid.template.disabled = true;
        categoryAxis.renderer.inside = true // make the chart as tight as possible
        categoryAxis.renderer.labels.template.dy = -28 // moves labels up on top of the bar
        categoryAxis.renderer.labels.template.fontSize = 13 // set font
        categoryAxis.renderer.labels.template.fontWeight = "bold" // set font
        
        // categoryAxis.startLocation = 1 // cuts of the left bullet, making it look like it's coming from infinite
        categoryAxis.endLocation = 1.4 // moves down from the top
        

        // Value Axis
        var valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minGridDistance = 30
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.min = 0;
        valueAxis.max = 100;
        valueAxis.strictMinMax = true;
        valueAxis.renderer.labels.template.adapter.add("text", function(text) {
            return text + "%";
        });
        valueAxis.renderer.labels.template.fontSize = 13 // set font
        valueAxis.renderer.labels.template.fontWeight = "bold" // set font
        valueAxis.renderer.labels.template.dx = 5
//        valueAxis.renderer.labels.template.dy = 18
        valueAxis.renderer.labels.template.fillOpacity = 1 // this works
//        valueAxis.renderer.inside = true // works
        valueAxis.max = 102 // gives more room on the right of a 100, but does not print it


        // Ranges
        function createRange(axis, from, to, color) {
            var range = axis.axisRanges.create();
            range.value = from;
            range.endValue = to;
            range.axisFill.fill = color;
            range.axisFill.fillOpacity = 0.8;
            range.label.disabled = true;
        }

        /*
        createRange(valueAxis, 0, 20, am4core.color("#ccff99"));
        createRange(valueAxis, 20, 40, am4core.color("#d1ffa3"));
        createRange(valueAxis, 40, 60, am4core.color("#d6ffad"));
        createRange(valueAxis, 60, 80, am4core.color("#d1ffa3")); 
        createRange(valueAxis, 80, 100, am4core.color("#ccff99"));
        */

        createRange(valueAxis, 0, 20, am4core.color("#FFFFFF"));
        createRange(valueAxis, 20, 40, am4core.color("#FFFFFF"));
        createRange(valueAxis, 40, 60, am4core.color("#FFFFFF"));
        createRange(valueAxis, 60, 80, am4core.color("#FFFFFF")); 
        createRange(valueAxis, 80, 100, am4core.color("#FFFFFF"));
        
        
        // Series 1
        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueX = "value";
        series.dataFields.categoryY = "category";
        series.columns.template.fill = am4core.color("#42A5F5") // lightning blue
        // series.columns.template.stroke = am4core.color("#94672B") // brown border
        series.columns.template.stroke = am4core.color("#3484c4") // dark blue border
        series.columns.template.strokeWidth = 2;
        //        series.columns.template.strokeOpacity = 0.5;
        series.columns.template.strokeOpacity = 1;
        series.columns.template.height = am4core.percent(25);


        // Series 2
        var series2 = chart.series.push(new am4charts.LineSeries());
        series2.dataFields.valueX = "target";
        series2.dataFields.categoryY = "category";
        series2.strokeWidth = 0;

        // Series 2 Bullet
        var bullet = series2.bullets.push(new am4charts.Bullet());
        bullet.layout = "absolute"
        var line = bullet.createChild(am4core.Line);
        line.x1 = 0;
        line.y1 = -15;
        line.x2 = 0;
        line.y2 = 15;
        line.stroke = am4core.color("#000000");
//        line.stroke = am4core.color("#FFFFFF");
        line.strokeWidth = 4;

        let title = chart.titles.create();
        title.text = this.props.title;
        title.fontSize = 15;
        title.fontWeight = "bold"
        title.marginTop = 10
        title.marginBottom = 30

        let label = chart.chartContainer.createChild(am4core.Label);
        label.fontSize = 13
        label.fontWeight = "bold"
//        label.marginTop = 20;
        label.text = "Hight Priority (Current vs. Last Month)";
        label.align = "center";

        // chart.background.fill = am4core.color("#CCFF99"); // green
        chart.background.fill = am4core.color("#FFFFFF"); // white background
        chart.paddingRight = 30 // this actually opens up sept 07, cuts it off otherwise
        this.chart = chart
        
    }
    

    componentWillUnmount() {
        if (this.chart) {
            this.chart.dispose();
        }
    }

    handleClick = () => {
        log.debug("handleClick()")
        this.setState({data: makeData()})
    }

    render() {
        const { classes } = this.props

        log.debug("render(): classes =", classes)
        log.debug("render(): state =", this.state)

        return (
            <div id="reasonsChartDiv"
                 style={{marginLeft: 0, width: "100%", height: "100%"}}
                 onClick={this.handleClick}>
            </div>
        )
    }
}


FlashReasonsChart.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {name: "FlashReasonsChart"})(FlashReasonsChart)
